import { FirebaseData } from "../../General/FirebaseData";
import { BookingLimit } from "./BookingUnitData";

export default class BookingUnitPropertyUnitData extends FirebaseData {

  limit?: BookingLimit = undefined

  setup(data: { [key: string]: any }) {
    this.limit = typeof data.limit === "object" ? data.limit : undefined;
    super.setup(data);
  }
}